<template>
  <section class="sp-ask-view-offer" aria-label="Explore this answer">
    <div class="sp-ask-view-offer-copy"><strong>{{ ready ? 'Your View is ready' : title }}</strong><span>{{ ready ? 'Explore the original work and connections in this View.' : description }}</span></div>
    <button type="button" class="sp-ask-view-offer-button" @click="$emit('explore')">{{ ready ? 'Open your View' : label }} <span class="sp-view-offer-arrow" aria-hidden="true">→</span></button>
  </section>
</template>
<script>
export default {
  name: 'AskViewOffer',
  props: { ready: Boolean, title: String, description: String, label: { type: String, default: 'Explore the story' } },
  emits: ['explore'],
};
</script>
<style scoped>
.sp-ask-view-offer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 0;
  padding: 14px 15px;
  background: rgba(var(--site-accent-rgb), 0.09);
  border: 0;
}
.sp-ask-view-offer-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}
.sp-ask-view-offer-copy strong {
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--site-accent-ink);
}
.sp-ask-view-offer-copy span {
  max-width: 34ch;
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.7rem;
  line-height: 1.45;
  color: #757a78;
}
.sp-ask-view-offer-button {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 0.42rem;
  flex: 0 0 auto;
  min-height: 2rem;
  padding: 0.5rem 0.65rem;
  border: 0;
  border-radius: 0;
  background: rgba(var(--site-accent-rgb), 0.09);
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--site-accent-strong);
  cursor: pointer;
  transition:
    color 160ms ease,
    background-color 160ms ease,
    transform 100ms ease-out;
}
.sp-view-offer-arrow {
  display: inline-block;
  color: var(--site-accent);
  font-size: 0.82rem;
  opacity: 0.72;
  transition: color 160ms ease, opacity 160ms ease, transform 180ms cubic-bezier(0.22, 1, 0.36, 1);
}
.sp-ask-view-offer-button:hover,
.sp-ask-view-offer-button:focus-visible {
  color: var(--site-accent-strong);
  background: rgba(var(--site-accent-rgb), 0.17);
}
.sp-ask-view-offer-button:hover .sp-view-offer-arrow,
.sp-ask-view-offer-button:focus-visible .sp-view-offer-arrow {
  color: var(--site-accent-strong);
  opacity: 1;
  transform: translateX(3px);
}
.sp-ask-view-offer-button:focus-visible {
  outline: 1px solid currentColor;
  outline-offset: 3px;
}
.sp-ask-view-offer-button:active {
  transform: scale(0.97);
}
:global(body.dark-mode .sp-ask-view-offer ){
  background: rgba(var(--site-accent-rgb), 0.08);
}
:global(body.dark-mode .sp-ask-view-offer-copy strong ){ color: var(--site-accent-ink); }
:global(body.dark-mode .sp-ask-view-offer-copy span ){ color: var(--site-accent-muted); }
:global(body.dark-mode .sp-ask-view-offer-button ){
  color: var(--site-accent-strong);
  background: rgba(var(--site-accent-rgb), 0.1);
}
:global(body.dark-mode .sp-ask-view-offer-button:hover),
:global(body.dark-mode .sp-ask-view-offer-button:focus-visible ){
  color: var(--site-accent-hover);
  background: rgba(var(--site-accent-rgb), 0.2);
}
:global(body.dark-mode .sp-view-offer-arrow ){ color: var(--site-accent-strong); }
:global(body.dark-mode .sp-ask-view-offer-button:hover .sp-view-offer-arrow),
:global(body.dark-mode .sp-ask-view-offer-button:focus-visible .sp-view-offer-arrow ){ color: var(--site-accent-hover); }
@media (max-width: 560px) {
  .sp-ask-view-offer { align-items: stretch; flex-direction: column; gap: 10px; }
  .sp-ask-view-offer-button { align-self: flex-start; }
}
@media (prefers-reduced-motion: reduce) {
  .sp-ask-view-offer-button,
  .sp-view-offer-arrow {
    transition-duration: 0.01ms;
  }
  .sp-ask-view-offer-button:hover,
  .sp-ask-view-offer-button:focus-visible {
    transform: none;
  }
  .sp-ask-view-offer-button:hover .sp-view-offer-arrow,
  .sp-ask-view-offer-button:focus-visible .sp-view-offer-arrow {
    transform: none;
  }
}
/* The card also fits inside the narrower homepage answer column. */
.sp-ask-view-offer { flex-wrap: wrap; }
.sp-ask-view-offer-copy { flex: 1 1 190px; }
@media (max-width: 560px) {
  .sp-ask-view-offer-copy { flex: 0 1 auto; }
}
</style>
